<template>
    <v-row class="ma-0 px-0">
        <exercise-img-video cols="3" is-second-dialog :video="exerciseVideo" :img="exerciseImg"/>
        <v-col cols="7" md="9">
            <div class="exercise-name text-truncate">
                {{ exercise.name }}
            </div>
            <div class="exercise-types text-truncate">
                {{ joinTypes }}
            </div>
            <div class="exercise-equipments text-truncate">
                {{ joinEquipments }}
            </div>
        </v-col>
        <v-col cols="2" md="1">
            <v-btn fab tile small class="kimsa-elevation" @click="addExercise(exercise)"
                   :color="added ? 'secondary' : 'white'">
                <v-icon v-if="oneExercise">mdi-repeat</v-icon>
                <v-icon v-else-if="added" color="black">mdi-minus</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

import ExerciseImgVideo from "@/components/common/routines/ExerciseImgVideo";

export default {
    components: {ExerciseImgVideo},
    props: {
        exercise: {
            type: Object,
            default: {},
        },
        added: {
            type: Boolean,
            default: false,
        },
        oneExercise: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        addExercise(exercise) {
            let vm = this
            vm.$emit('add', exercise)
        },
    },
    computed: {
        exerciseImg(vm = this) {
            return vm.exercise?.img || vm.exercise?.video?.thumb || vm.imgPlaceholder
        },
        exerciseVideo(vm = this) {
            return vm.exercise?.video?.url || null
        },
        joinTypes(vm = this) {
            return vm.exercise.types.join(', ')
        },
        joinEquipments(vm = this) {
            if (!vm.exercise.equipments || vm.exercise.equipments.length === 0) return vm.$t('equipments.without')
            return vm.exercise.equipments.join(',')
        }
    }
}
</script>

<style scoped>

.exercise-name {
    font-size: 15px;
    color: #333333;
}

.exercise-types {
    font-size: 11px;
    color: #707070;
}

.exercise-equipments {
    font-size: 11px;
    color: #707070;
}

</style>